import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const CATALOG_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_CATALOG_MGMT,
  SEGREGATION: `${ROUTES.ADMIN_CATALOG_MGMT}/segregation`,
  STEP_ONE: `${ROUTES.ADMIN_CATALOG_MGMT}/stepOne`,
  STEP_TWO: `${ROUTES.ADMIN_CATALOG_MGMT}/stepTwo`,
  STEP_THREE: `${ROUTES.ADMIN_CATALOG_MGMT}/stepThree`,
  SUMMARY: `${ROUTES.ADMIN_CATALOG_MGMT}/summary`,
};

export const ENTITLEMENT_MANAGEMENT_CATALOG_MGMT_CONSOLE_ADMIN_FORM_FILTER =
  "EntitlementManagementCatalogMgmtConsoleAdminFormFilter";

export const STATE_IDENTIFIER = {
  OFFICES: "offices",
  SELECTED_OFFICE: "selectedOffice",
  SHOW_ADVANCED_FILTER: "showAdvancedFilter",
  SELECTED_USERS: "selectedOffice",
  SELECTED_ENTITLEMENTS: "selectedEntitlements",
  IS_POSSIBLE_TO_CONTINUE: "isPossibleToContinue",
  LOADER_LIST_IDENTIFIER: "loaderListEntitlements",
  LIST_ENTITLEMENTS: "listEntitlements",
  TOTAL_ENTITLEMENTS: "totalEntitlements",
  ADDED_ENTITLEMENTS: "addedEntitlements",
  DELETED_ENTITLEMENTS: "deletedEntitlements",
  MODIFIED_ENTITLEMENTS: "modifiedEntitlements",
  PREV_ENTITLEMENTS: "prevEntitlements",
  CHAIN_ENTITLEMENTS: "chainEntitlements",
  CALL_STATE: "callState",
  STEP_ONE: "stepOne",
  STEP_TWO: "stepTwo",
  SELECTED_CATALOG: "selectedCatalog",
  USERS_LIST: "usersList",
  START_END_DATE: "startEndDate",
  SEGREGATIONS: "segregations",
  ENRICHMENTS: "enrichments",
  UPDATED_SEGREGATION: "updatedSegregation",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
